import { render } from "./App.vue?vue&type=template&id=6c6fa287"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6c6fa287&lang=scss"

import exportComponent from "D:\\Git\\monetwareProjects\\kunqu-opera-test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__